import {cs} from "@common/react/chain-services";
import * as React from "react";
import {ConnectedTiles} from "../connected-tiles/connected-tiles";
import "./filter-connected-tiles-tab.scss";

export const FilterConnectedTilesTab = ({filter, form}) =>
    cs(({}) => {
        return <div className="filter-connected-tiles-tab-h56">{ConnectedTiles({filter})}</div>;
    });
